import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { UPDATE_BID_DETAILS_FORM_NAME } from 'Common/FormEnum';
import UpdateBidDetailsComponent from '../components/UpdateBidDetails';

class UpdateBidDetails extends Component {
  static propTypes = {
    assignItemsBidGroupData: PropTypes.array.isRequired,
    assignItemsItemGroupData: PropTypes.array.isRequired,
    assignItemsVendorData: PropTypes.array.isRequired,
    bidDetailsData: PropTypes.array.isRequired,
    acctCategoryData: PropTypes.array.isRequired,
    handleChange: PropTypes.func,
    filterValues: PropTypes.object,
    clearFilters: PropTypes.func,
    handleAsOfDateCheckBoxChange: PropTypes.func,
    handleVendorChange: PropTypes.func,
    handleClick: PropTypes.func,
    onSortedChange: PropTypes.func,
    onFilteredChange: PropTypes.func,
    handleAsOfDateChange: PropTypes.func,
    onSubmit: PropTypes.func,
    loadingBidDetails: PropTypes.bool,
    isAsOfDateChecked: PropTypes.bool,
    activeIndexes: PropTypes.array,
    sorted: PropTypes.array,
    filtered: PropTypes.array,
  };
  static defaultProps = {
    handleChange: () => {},
    filterValues: {},
    clearFilters: () => {},
    handleAsOfDateChange: () => {},
    handleAsOfDateCheckBoxChange: () => {},
    handleVendorChange: () => {},
    handleClick: () => {},
    onSortedChange: () => {},
    onFilteredChange: () => {},
    loadingBidDetails: false,
    isAsOfDateChecked: false,
    activeIndexes: [],
    sorted: [],
    filtered: [],
  };
  render() {
    const {
      bidDetailsData,
      assignItemsBidGroupData,
      assignItemsItemGroupData,
      assignItemsVendorData,
      acctCategoryData,
      loadingBidDetails,
      updateBidDetailsInfo,
      handleChange,
      filterValues,
      clearFilters,
      handleAsOfDateChange,
      handleAsOfDateCheckBoxChange,
      isAsOfDateChecked,
      handleSubmit,
      handleVendorChange,
      activeIndexes,
      handleClick,
      sorted,
      filtered,
      onSortedChange,
      onFilteredChange,
    } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <UpdateBidDetailsComponent
          assignItemsBidGroupData={assignItemsBidGroupData}
          assignItemsItemGroupData={assignItemsItemGroupData}
          assignItemsVendorData={assignItemsVendorData}
          bidDetailsData={bidDetailsData}
          acctCategoryData={acctCategoryData}
          loadingBidDetails={loadingBidDetails}
          handleChange={handleChange}
          filterValues={filterValues}
          clearFilters={clearFilters}
          handleAsOfDateChange={handleAsOfDateChange}
          handleAsOfDateCheckBoxChange={handleAsOfDateCheckBoxChange}
          isAsOfDateChecked={isAsOfDateChecked}
          updateBidDetailsInfo={updateBidDetailsInfo}
          handleVendorChange={handleVendorChange}
          activeIndexes={activeIndexes}
          handleClick={handleClick}
          sorted={sorted}
          filtered={filtered}
          onSortedChange={onSortedChange}
          onFilteredChange={onFilteredChange}
        />
      </Form>
    );
  }
}

export const UpdateBidDetailsContainer = reduxForm({
  form: UPDATE_BID_DETAILS_FORM_NAME,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
})(UpdateBidDetails);



// WEBPACK FOOTER //
// ./src/pages/utilities/updatebiddetails/containers/UpdateBidDetails.js